import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  applyKajikajyTheme,
  getInitialKajikajyTheme
} from "@kajikajy/shared";
import App from "./App";
import "./styles.css";

applyKajikajyTheme(getInitialKajikajyTheme());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
